import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { ContentColumnStyleProps, contentColumnStyles } from './atoms/content-column/list-row-content-column.styles';
import { trailingColumnStyles } from './atoms/trailing-column/list-row-trailing-column.styles';
import { TrailingColumnComponentProps } from './atoms/trailing-column/types';

export type ListRowStylesProps = {
  isClickable?: boolean;
  isSelected?: boolean;
};

const listRowBaseStyle = css`
  position: relative;
  width: 100%;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${theme.colors.neutral20};
  display: grid;
  grid-template-areas: 'lead content trail';
  grid-template-columns: min-content;
  padding-top: ${theme.spacing(2)};
  padding-right: ${theme.spacing(2)};
  padding-bottom: ${theme.spacing(2)};
  padding-left: ${theme.spacing(2)};
  transition: background-color 250ms ease-out;
  &:focus-visible {
    outline-width: 1px;
    outline-style: solid;
    outline-color: ${theme.colors.primary50};
  }
`;

const listRowClickableStyle = css`
  &:hover {
    background-color: ${theme.colors.neutral5};
    cursor: pointer;
  }
`;

const listRowSelectedStyle = css`
  background-color: ${theme.colors.neutral5};
`;

const listRowStyles = ({ isClickable, isSelected }: ListRowStylesProps) =>
  cx(listRowBaseStyle, isClickable && listRowClickableStyle, isSelected && listRowSelectedStyle);

const listRowIndicatorStyles = css`
  position: absolute;
  left: 0;
  top: 0;
  width: 8px;
  height: 100%;
  background-color: ${theme.colors.primary50};
`;

export const ListRowStyles = {
  Indicator: listRowIndicatorStyles,
  Row: (props: ListRowStylesProps) => listRowStyles(props),
  ContentColumn: (props: ContentColumnStyleProps) => contentColumnStyles(props),
  TrailingColumn: (props: TrailingColumnComponentProps) => trailingColumnStyles(props),
};
